import React, { useState } from "react";
import api from "../api/api";
import { useNavigate } from "react-router-dom";
import { FormData } from "../types/Mitglied";

const Register = () => {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const [formData, setFormData] = useState<FormData>({
    username: "",
    password: "",
    vorname: "",
    nachname: "",
    email: "",
    geburtsdatum: "",
    adresse: "",
    telefon: "",
    mitgliedsstatus: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      await api.post("/register", formData);
      setSuccess(
        "🎉 Registrierung erfolgreich! Du kannst dich jetzt anmelden.",
      );
      setFormData({
        username: "",
        password: "",
        vorname: "",
        nachname: "",
        email: "",
        geburtsdatum: "",
        adresse: "",
        telefon: "",
        mitgliedsstatus: "",
      });
      setTimeout(() => {
        navigate("/login");
      }, 1500); // 1,5 Sekunden
    } catch (err: any) {
      setError(err.response?.data?.message || "Registrierung fehlgeschlagen");
    }
  };

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      <h2>Register</h2>

      <input
        name="username"
        value={formData.username}
        onChange={handleChange}
        placeholder="Username"
      />
      <input
        type="password"
        name="password"
        value={formData.password}
        onChange={handleChange}
        placeholder="Password"
      />
      <input
        name="vorname"
        value={formData.vorname}
        onChange={handleChange}
        placeholder="Vorname"
      />
      <input
        name="nachname"
        value={formData.nachname}
        onChange={handleChange}
        placeholder="Nachname"
      />
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="E-Mail"
      />
      <input
        type="date"
        name="geburtsdatum"
        value={formData.geburtsdatum}
        onChange={handleChange}
      />
      <input
        name="adresse"
        value={formData.adresse}
        onChange={handleChange}
        placeholder="Adresse"
      />
      <input
        name="telefon"
        value={formData.telefon}
        onChange={handleChange}
        placeholder="Telefonnummer"
      />
      <input
        name="mitgliedsstatus"
        value={formData.mitgliedsstatus}
        onChange={handleChange}
        placeholder="Mitgliedsstatus"
      />

      <button type="submit">Register</button>

      {success && <p style={{ color: "green" }}>{success}</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
    </form>
  );
};

export default Register;
